(() => {
  'use strict';
  function init(root) {
    if(root.dataset.lmReady)return;
    root.dataset.lmReady='true';
    const priceBlock=root.querySelector('[data-lm-block="price"]');
    const header=root.querySelector('[data-lm-heading]');
    const mobileHeading=root.querySelector('[data-lm-mobile-heading]');
    const meta=root.querySelector('.product-single__meta');
    const blocks=root.querySelector('[data-product-blocks]');
    const form=root.querySelector('form.product-single__form');
    const select=root.querySelector('[data-product-select]');
    const add=root.querySelector('[data-add-to-cart]');
    const json=root.querySelector('[data-variant-json]');
    const sticky=document.querySelector(`[data-lm-owner="${root.id}"]`);
    if(!json||!form||!add)return;
    const variants=JSON.parse(json.value||json.textContent);
    const headingAnchor=document.createComment('lm-heading-position');
    const priceAnchor=document.createComment('lm-price-position');
    header.before(headingAnchor);
    priceBlock?.before(priceAnchor);
    const mq=matchMedia('(max-width: 768px)');
    function arrange(){
      if(mq.matches){mobileHeading.append(header);if(priceBlock)mobileHeading.append(priceBlock);}
      else{headingAnchor.after(header);if(priceBlock)priceAnchor.after(priceBlock);}
    }
    arrange();
    mq.addEventListener('change',arrange);
    function currentVariant(){
      const inputs=[...root.querySelectorAll('[data-variant-input]:checked')];
      return variants.find(v=>inputs.every(input=>v['option'+input.dataset.index.replace('option','')]===input.value)) ||
        variants.find(v=>String(v.id)===select?.value);
    }
    function sync(){
      const variant=currentVariant();
      const selected=variant?.title || [...root.querySelectorAll('[data-variant-input]:checked')].map(i=>i.value).join(' / ');
      root.querySelectorAll('[data-lm-selection]').forEach(el=>el.textContent=selected);
      const single=variant?.options?.some(v=>String(v).toLowerCase().includes('single'));
      root.querySelectorAll('[data-lm-pillow-count]').forEach(el=>el.textContent=single?'1':'2');
      if(sticky){
        sticky.querySelector('[data-lm-sticky-selection]').textContent=selected;
        const price=root.querySelector('[data-product-price]');
        if(price)sticky.querySelector('[data-lm-sticky-price]').textContent=price.textContent;
        const submit=sticky.querySelector('button');
        submit.disabled=add.disabled;
        submit.textContent=add.querySelector('[data-add-to-cart-text]')?.textContent.trim()||add.textContent.trim();
        sticky.hidden=add.getBoundingClientRect().bottom>=0 || !mq.matches;
      }
    }
    let frame;
    const queue=()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=null;sync()})};
    root.addEventListener('change',()=>{queue();setTimeout(queue,120)});
    document.addEventListener('variant:change',queue);
    window.addEventListener('scroll',queue,{passive:true});
    window.addEventListener('resize',queue);
    new MutationObserver(queue).observe(add,{attributes:true,childList:true,subtree:true});
    const price=root.querySelector('[data-product-price]');
    if(price)new MutationObserver(queue).observe(price,{childList:true,subtree:true});
    sticky?.querySelector('[data-lm-sticky-submit]').addEventListener('click',()=>{
      // Use the real button so native validation and Zepto property handling run.
      if(!add.disabled)add.click();
    });
    sync();
  }
  const boot=()=>document.querySelectorAll('[data-lm-pdp]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
